"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _component = _interopRequireDefault(require("../component.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*---------------------------------------------*/
var Grid = /*#__PURE__*/function (_Component) {
  _inherits(Grid, _Component);

  var _super = _createSuper(Grid);

  function Grid() {
    var _this;

    _classCallCheck(this, Grid);

    _this = _super.call(this);
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Grid, [{
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault();
      this.props.onSubmit && this.props.onSubmit();
    }
  }, {
    key: "render",
    value: function render() {
      this.resetClassNames();
      this.addClass(this.constructor.BASE_CLASS);

      if (this.props.showGrid) {
        this.addClass(this.constructor.BASE_CLASS + "--showgrid");
      }

      this.props.fluid && this.addClass("".concat(this.constructor.BASE_CLASS, "--fluid"));
      this.props.condensed && this.addClass("".concat(this.constructor.BASE_CLASS, "--condensed"));
      this.props.narrow && this.addClass("".concat(this.constructor.BASE_CLASS, "--narrow"));
      this.props.nomargin && this.addClass("".concat(this.constructor.BASE_CLASS, "--nomargin"));

      var children = _react.default.Children.map(this.props.children, function (child, index) {
        if (!child || !child.props) {
          return child;
        }

        var style = child.props.style;
        style = _objectSpread(_objectSpread({}, style), {}, {
          gridColumnStart: style && style.gridColumnStart || child.props["gridStart"] || child.props["grid-start"] || 1,
          gridColumnEnd: style && style.gridColumnEnd || child.props["gridEnd"] || child.props["grid-end"] || -1
        });
        return /*#__PURE__*/_react.default.cloneElement(child, {
          style: style
        });
      });

      var stub = null;

      if (this.props.showGrid) {
        stub = _toConsumableArray(Array(16)).map(function (x, index) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "stub",
            style: {
              gridStart: index + 1,
              gridEnd: index + 2
            }
          });
        });
      }

      var gridStyle = Object.assign({}, this.getStyle(), {
        "--rows": this.props.rows
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        style: gridStyle,
        className: this.getClassNames()
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: this.constructor.BASE_CLASS + "__container",
        style: {
          alignItems: this.props.align
        }
      }, children, stub));
    }
  }]);

  return Grid;
}(_component.default);
/*---------------------------------------------*/


exports.default = Grid;

_defineProperty(Grid, "BASE_CLASS", "lth-l-grid");

Grid.Container = function (props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    style: props.style
  }, props.children);
};
/*---------------------------------------------*/


Grid.METADATA = {
  name: "Grid",
  props: [{
    name: "fluid",
    type: "boolean"
  }, {
    name: "condensed",
    type: "boolean"
  }, {
    name: "narrow",
    type: "boolean"
  }, {
    name: "nomargin",
    type: "boolean"
  }],
  demo: {
    props: {
      showGrid: true
    }
  }
};